<template>
  <div class="fragment">
    <div class="input-col">
      <div class="form-field form-textbox form-group">
        <label class="k-textbox-label" :for="propName">{{ displayLabel }}</label>
        <input
          v-if="isNumeric"
          v-model.number="formData[propName]"
          :id="propName"
          :tabindex="tabindex"
          class="k-textbox"
          :style="{ borderRight: inputBorderColor }"
        />
        <input
          v-else
          v-model="formData[propName]"
          :id="propName"
          :tabindex="tabindex"
          :disabled="disabled"
          type="text"
          class="k-textbox"
          :style="{ borderRight: inputBorderColor }"
        />
        <input
          v-if="showAverageResults && includeAverage"
          :value="formData[propAverageName]"
          tabindex="-1"
          class="k-textbox result-average"
          disabled
        />
      </div>
    </div>
    <div class="input-col">
      <AutoComplete
        v-if="isWater"
        :tabindex="tabindex + 1"
        store="UnitOfMeasure"
        :mapping="mappings.WaterUnitOfMeasure"
        placeholder=""
        :disabled="true"
        :isWater="isWater"
        :formData="formData"
        :removeLabelClass="removeLabelClass"
      />
      <SeverityDropdown
        :propID="propSeverityName ? this.propSeverityName : `${this.propName}SeverityID`"
        :tabindex="-1"
        :formData="formData"
        :disabled="disabled"
      />
    </div>
  </div>
</template>

<script>
import StringHelper from 'services/string-helper.service';
import BaselineSampleHelperService from 'services/baseline-sample-helper.service';
import SeverityDropdown from '../../shared/SeverityDropdown.vue';
import AutoComplete from '../../shared/AutoComplete.vue';

export default {
  name: 'SampleResultParticleControl',
  computed: {
    displayLabel() {
      return this.label ? this.label : StringHelper.fieldToTitle(this.propName);
    },
    inputBorderColor() {
      const value = this.formData[this.propName];
      const average = this.formData[this.propAverageName];
      return BaselineSampleHelperService.getInputBorderColor(value, average);
    }
  },
  components: {
    SeverityDropdown,
    AutoComplete
  },
  props: {
    disabled: {
      type: Boolean,
      default() {
        return false;
      }
    },
    label: {
      type: String
    },
    tabindex: {
      type: Number,
      default() {
        return 0;
      }
    },
    propName: {
      type: String
    },
    propAverageName: {
      type: String
    },
    propSeverityName: {
      type: String
    },
    formData: {
      type: Object
    },
    showAverageResults: {
      type: Boolean
    },
    includeAverage: {
      type: Boolean,
      default() {
        return true;
      }
    },
    mappings: {
      type: Object,
      required: true
    },
    includeAverage: {
      type: Boolean,
      default() {
        return true;
      }
    },
    isWater: {
      type: Boolean,
      default() {
        return false;
      }
    },
    isNumeric: {
      type: Boolean,
      default() {
        return true;
      }
    },
    removeLabelClass: Boolean,
    decimalPlaces: {
      type: Number,
      default() {
        return -1;
      }
    },
    roundDecimals: {
      type: Boolean,
      default() {
        return false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.form-textbox {
  align-items: center;
  display: flex;
}

.k-textbox-label {
  display: inline-block;
  min-width: 120px !important;
  width: 120px !important;
}

.k-textbox {
  width: 75px;
}

.result-average {
  margin-left: 5px;
}

.input-col {
  display: flex;
  flex-basis: 15%;
}
</style>
